import {Heading, ModalBody, ModalCloseButton, ModalContent, ModalHeader, Text} from '@chakra-ui/react';
import {IModalProps, Modal} from 'components/shared';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {TranslationKeys} from 'translations';

interface IProps extends IModalProps {
  t: (term: TranslationKeys) => string;
}

export const DeliveryCostInfoModal: FC<IProps> = ({isOpen, onClose, t}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent mx={['10px', 0]}>
        <ModalHeader display="flex" alignItems="center" justifyContent="space-between">
          <Heading fontSize={['18px', '24px']} fontWeight="bold">
            {t('DELIVERY_COST_INFO_TITLE')}
          </Heading>
          <ModalCloseButton position="static" sx={modalCloseButtonStyles} />
        </ModalHeader>
        <ModalBody p="5">
          <>
            <Text fontWeight={500} fontSize={['12px', '16px']}>
              {t('DELIVERY_COST_INFO_DESCRIPTION_PART1')}
            </Text>
            <Text mt="10px" fontWeight={500} fontSize={['12px', '16px']}>
              {t('DELIVERY_COST_INFO_DESCRIPTION_PART2')}
            </Text>
          </>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
